/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardCreateTeam,
  DashboardLeagueList,
  DashboardTeamDetail,
  DashboardTeamInvite,
  DashboardTeamInviteResult,
  DashboardTeamList,
  DashboardTeamRef,
  DashboardTeamsControllerCreate400,
  DashboardTeamsControllerCreate401,
  DashboardTeamsControllerCreate429,
  DashboardTeamsControllerDetail400,
  DashboardTeamsControllerDetail401,
  DashboardTeamsControllerDetail404,
  DashboardTeamsControllerDetail429,
  DashboardTeamsControllerExport400,
  DashboardTeamsControllerExport401,
  DashboardTeamsControllerExport413,
  DashboardTeamsControllerExport429,
  DashboardTeamsControllerExportParams,
  DashboardTeamsControllerInvite400,
  DashboardTeamsControllerInvite401,
  DashboardTeamsControllerInvite404,
  DashboardTeamsControllerInvite429,
  DashboardTeamsControllerLeagues400,
  DashboardTeamsControllerLeagues401,
  DashboardTeamsControllerLeagues404,
  DashboardTeamsControllerLeagues429,
  DashboardTeamsControllerLeaguesParams,
  DashboardTeamsControllerList400,
  DashboardTeamsControllerList401,
  DashboardTeamsControllerList429,
  DashboardTeamsControllerListParams,
  DashboardTeamsControllerRefs400,
  DashboardTeamsControllerRefs401,
  DashboardTeamsControllerRefs429,
  DashboardTeamsControllerRefsParams,
  DashboardTeamsControllerRemove400,
  DashboardTeamsControllerRemove401,
  DashboardTeamsControllerRemove404,
  DashboardTeamsControllerRemove409,
  DashboardTeamsControllerRemove429,
  DashboardTeamsControllerTournaments400,
  DashboardTeamsControllerTournaments401,
  DashboardTeamsControllerTournaments404,
  DashboardTeamsControllerTournaments429,
  DashboardTeamsControllerTournamentsParams,
  DashboardTeamsControllerUpdate400,
  DashboardTeamsControllerUpdate401,
  DashboardTeamsControllerUpdate404,
  DashboardTeamsControllerUpdate429,
  DashboardTournamentList,
  DashboardUpdateTeam,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Paginated team list scoped to the caller: the `TEAM:READ` capability universe UNION the legacy accessible sets. `platformIds` and `federationIds` are pure filters applied together (AND of axes); the platform filter reads the authoritative `team.platformId` attribution — a team with no platform attribution counts as a wildcard over the platforms its federation is linked to. Requesting an out-of-scope id yields a narrowed (possibly empty) page, never a 403. Filters: keyword, platform / federation / sport / club ids, ISO country codes, lifecycle status, registration period range. 1-based `page`, default `limit` 20.
 * @summary List teams (dashboard)
 */
export const dashboardTeamsControllerList = (
  params?: DashboardTeamsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTeamList>(
    { url: `/api/dashboard/v1/teams`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTeamsControllerListQueryKey = (
  params?: DashboardTeamsControllerListParams
) => {
  return [`/api/dashboard/v1/teams`, ...(params ? [params] : [])] as const;
};

export const getDashboardTeamsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerList>>,
  TError = ErrorType<
    | DashboardTeamsControllerList400
    | DashboardTeamsControllerList401
    | DashboardTeamsControllerList429
  >,
>(
  params?: DashboardTeamsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTeamsControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardTeamsControllerList>>> = ({
    signal,
  }) => dashboardTeamsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTeamsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerList>>
>;
export type DashboardTeamsControllerListQueryError = ErrorType<
  | DashboardTeamsControllerList400
  | DashboardTeamsControllerList401
  | DashboardTeamsControllerList429
>;

export function useDashboardTeamsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerList>>,
  TError = ErrorType<
    | DashboardTeamsControllerList400
    | DashboardTeamsControllerList401
    | DashboardTeamsControllerList429
  >,
>(
  params: undefined | DashboardTeamsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerList>>,
  TError = ErrorType<
    | DashboardTeamsControllerList400
    | DashboardTeamsControllerList401
    | DashboardTeamsControllerList429
  >,
>(
  params?: DashboardTeamsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerList>>,
  TError = ErrorType<
    | DashboardTeamsControllerList400
    | DashboardTeamsControllerList401
    | DashboardTeamsControllerList429
  >,
>(
  params?: DashboardTeamsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List teams (dashboard)
 */

export function useDashboardTeamsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerList>>,
  TError = ErrorType<
    | DashboardTeamsControllerList400
    | DashboardTeamsControllerList401
    | DashboardTeamsControllerList429
  >,
>(
  params?: DashboardTeamsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTeamsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new team. The roster (if supplied) must satisfy the single-captain rule. Returns the full team detail.
 * @summary Create team (dashboard)
 */
export const dashboardTeamsControllerCreate = (
  dashboardCreateTeam: BodyType<DashboardCreateTeam>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTeamDetail>(
    {
      url: `/api/dashboard/v1/teams`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateTeam,
      signal,
    },
    options
  );
};

export const getDashboardTeamsControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardTeamsControllerCreate400
    | DashboardTeamsControllerCreate401
    | DashboardTeamsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateTeam> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTeamsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateTeam> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTeamsControllerCreate>>,
    { data: BodyType<DashboardCreateTeam> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardTeamsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTeamsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerCreate>>
>;
export type DashboardTeamsControllerCreateMutationBody = BodyType<DashboardCreateTeam>;
export type DashboardTeamsControllerCreateMutationError = ErrorType<
  | DashboardTeamsControllerCreate400
  | DashboardTeamsControllerCreate401
  | DashboardTeamsControllerCreate429
>;

/**
 * @summary Create team (dashboard)
 */
export const useDashboardTeamsControllerCreate = <
  TError = ErrorType<
    | DashboardTeamsControllerCreate400
    | DashboardTeamsControllerCreate401
    | DashboardTeamsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateTeam> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTeamsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateTeam> },
  TContext
> => {
  const mutationOptions = getDashboardTeamsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Batched `id → { id, title, image }` lookup for filter-chip rehydration. Ids the caller cannot reach are silently dropped.
 * @summary Resolve team ids to slim refs (dashboard)
 */
export const dashboardTeamsControllerRefs = (
  params: DashboardTeamsControllerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTeamRef[]>(
    { url: `/api/dashboard/v1/teams/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTeamsControllerRefsQueryKey = (
  params: DashboardTeamsControllerRefsParams
) => {
  return [`/api/dashboard/v1/teams/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardTeamsControllerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>,
  TError = ErrorType<
    | DashboardTeamsControllerRefs400
    | DashboardTeamsControllerRefs401
    | DashboardTeamsControllerRefs429
  >,
>(
  params: DashboardTeamsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTeamsControllerRefsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>> = ({
    signal,
  }) => dashboardTeamsControllerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTeamsControllerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>
>;
export type DashboardTeamsControllerRefsQueryError = ErrorType<
  | DashboardTeamsControllerRefs400
  | DashboardTeamsControllerRefs401
  | DashboardTeamsControllerRefs429
>;

export function useDashboardTeamsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>,
  TError = ErrorType<
    | DashboardTeamsControllerRefs400
    | DashboardTeamsControllerRefs401
    | DashboardTeamsControllerRefs429
  >,
>(
  params: DashboardTeamsControllerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>,
  TError = ErrorType<
    | DashboardTeamsControllerRefs400
    | DashboardTeamsControllerRefs401
    | DashboardTeamsControllerRefs429
  >,
>(
  params: DashboardTeamsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>,
  TError = ErrorType<
    | DashboardTeamsControllerRefs400
    | DashboardTeamsControllerRefs401
    | DashboardTeamsControllerRefs429
  >,
>(
  params: DashboardTeamsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve team ids to slim refs (dashboard)
 */

export function useDashboardTeamsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>,
  TError = ErrorType<
    | DashboardTeamsControllerRefs400
    | DashboardTeamsControllerRefs401
    | DashboardTeamsControllerRefs429
  >,
>(
  params: DashboardTeamsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTeamsControllerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export with filter parity against `GET /teams`. No pagination; 100k row cap (413 EXPORT_TOO_LARGE).
 * @summary Export teams (dashboard)
 */
export const dashboardTeamsControllerExport = (
  params: DashboardTeamsControllerExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    { url: `/api/dashboard/v1/teams/export`, method: "GET", params, responseType: "blob", signal },
    options
  );
};

export const getDashboardTeamsControllerExportQueryKey = (
  params: DashboardTeamsControllerExportParams
) => {
  return [`/api/dashboard/v1/teams/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardTeamsControllerExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerExport>>,
  TError = ErrorType<
    | DashboardTeamsControllerExport400
    | DashboardTeamsControllerExport401
    | DashboardTeamsControllerExport413
    | DashboardTeamsControllerExport429
  >,
>(
  params: DashboardTeamsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTeamsControllerExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardTeamsControllerExport>>> = ({
    signal,
  }) => dashboardTeamsControllerExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTeamsControllerExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerExport>>
>;
export type DashboardTeamsControllerExportQueryError = ErrorType<
  | DashboardTeamsControllerExport400
  | DashboardTeamsControllerExport401
  | DashboardTeamsControllerExport413
  | DashboardTeamsControllerExport429
>;

export function useDashboardTeamsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerExport>>,
  TError = ErrorType<
    | DashboardTeamsControllerExport400
    | DashboardTeamsControllerExport401
    | DashboardTeamsControllerExport413
    | DashboardTeamsControllerExport429
  >,
>(
  params: DashboardTeamsControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerExport>>,
  TError = ErrorType<
    | DashboardTeamsControllerExport400
    | DashboardTeamsControllerExport401
    | DashboardTeamsControllerExport413
    | DashboardTeamsControllerExport429
  >,
>(
  params: DashboardTeamsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerExport>>,
  TError = ErrorType<
    | DashboardTeamsControllerExport400
    | DashboardTeamsControllerExport401
    | DashboardTeamsControllerExport413
    | DashboardTeamsControllerExport429
  >,
>(
  params: DashboardTeamsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export teams (dashboard)
 */

export function useDashboardTeamsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerExport>>,
  TError = ErrorType<
    | DashboardTeamsControllerExport400
    | DashboardTeamsControllerExport401
    | DashboardTeamsControllerExport413
    | DashboardTeamsControllerExport429
  >,
>(
  params: DashboardTeamsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTeamsControllerExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Full team detail. 404 when the team doesn't exist or is out of the caller's scope.
 * @summary Get team detail (dashboard)
 */
export const dashboardTeamsControllerDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTeamDetail>(
    { url: `/api/dashboard/v1/teams/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardTeamsControllerDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/teams/${id}`] as const;
};

export const getDashboardTeamsControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>,
  TError = ErrorType<
    | DashboardTeamsControllerDetail400
    | DashboardTeamsControllerDetail401
    | DashboardTeamsControllerDetail404
    | DashboardTeamsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTeamsControllerDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>> = ({
    signal,
  }) => dashboardTeamsControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTeamsControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>
>;
export type DashboardTeamsControllerDetailQueryError = ErrorType<
  | DashboardTeamsControllerDetail400
  | DashboardTeamsControllerDetail401
  | DashboardTeamsControllerDetail404
  | DashboardTeamsControllerDetail429
>;

export function useDashboardTeamsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>,
  TError = ErrorType<
    | DashboardTeamsControllerDetail400
    | DashboardTeamsControllerDetail401
    | DashboardTeamsControllerDetail404
    | DashboardTeamsControllerDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>,
  TError = ErrorType<
    | DashboardTeamsControllerDetail400
    | DashboardTeamsControllerDetail401
    | DashboardTeamsControllerDetail404
    | DashboardTeamsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>,
  TError = ErrorType<
    | DashboardTeamsControllerDetail400
    | DashboardTeamsControllerDetail401
    | DashboardTeamsControllerDetail404
    | DashboardTeamsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get team detail (dashboard)
 */

export function useDashboardTeamsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>,
  TError = ErrorType<
    | DashboardTeamsControllerDetail400
    | DashboardTeamsControllerDetail401
    | DashboardTeamsControllerDetail404
    | DashboardTeamsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTeamsControllerDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update. When `members` is supplied it replaces the entire roster. Absent fields are left untouched. 404 when the team is out of scope so existence isn't probable.
 * @summary Update team (dashboard)
 */
export const dashboardTeamsControllerUpdate = (
  id: string,
  dashboardUpdateTeam: BodyType<DashboardUpdateTeam>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardTeamDetail>(
    {
      url: `/api/dashboard/v1/teams/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateTeam,
    },
    options
  );
};

export const getDashboardTeamsControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardTeamsControllerUpdate400
    | DashboardTeamsControllerUpdate401
    | DashboardTeamsControllerUpdate404
    | DashboardTeamsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateTeam> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTeamsControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateTeam> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTeamsControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdateTeam> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardTeamsControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTeamsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerUpdate>>
>;
export type DashboardTeamsControllerUpdateMutationBody = BodyType<DashboardUpdateTeam>;
export type DashboardTeamsControllerUpdateMutationError = ErrorType<
  | DashboardTeamsControllerUpdate400
  | DashboardTeamsControllerUpdate401
  | DashboardTeamsControllerUpdate404
  | DashboardTeamsControllerUpdate429
>;

/**
 * @summary Update team (dashboard)
 */
export const useDashboardTeamsControllerUpdate = <
  TError = ErrorType<
    | DashboardTeamsControllerUpdate400
    | DashboardTeamsControllerUpdate401
    | DashboardTeamsControllerUpdate404
    | DashboardTeamsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateTeam> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTeamsControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateTeam> },
  TContext
> => {
  const mutationOptions = getDashboardTeamsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Remove a team. Fails with 409 TEAM_IN_USE when the team is registered in any tournament.
 * @summary Delete team (dashboard)
 */
export const dashboardTeamsControllerRemove = (
  id: string,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>({ url: `/api/dashboard/v1/teams/${id}`, method: "DELETE" }, options);
};

export const getDashboardTeamsControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardTeamsControllerRemove400
    | DashboardTeamsControllerRemove401
    | DashboardTeamsControllerRemove404
    | DashboardTeamsControllerRemove409
    | DashboardTeamsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTeamsControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTeamsControllerRemove>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dashboardTeamsControllerRemove(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTeamsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerRemove>>
>;

export type DashboardTeamsControllerRemoveMutationError = ErrorType<
  | DashboardTeamsControllerRemove400
  | DashboardTeamsControllerRemove401
  | DashboardTeamsControllerRemove404
  | DashboardTeamsControllerRemove409
  | DashboardTeamsControllerRemove429
>;

/**
 * @summary Delete team (dashboard)
 */
export const useDashboardTeamsControllerRemove = <
  TError = ErrorType<
    | DashboardTeamsControllerRemove400
    | DashboardTeamsControllerRemove401
    | DashboardTeamsControllerRemove404
    | DashboardTeamsControllerRemove409
    | DashboardTeamsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTeamsControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDashboardTeamsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Send a team invitation email. Replaces the legacy `sendTeamInvite` flow.
 * @summary Send team invite (dashboard)
 */
export const dashboardTeamsControllerInvite = (
  id: string,
  dashboardTeamInvite: BodyType<DashboardTeamInvite>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTeamInviteResult>(
    {
      url: `/api/dashboard/v1/teams/${id}/invite`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardTeamInvite,
      signal,
    },
    options
  );
};

export const getDashboardTeamsControllerInviteMutationOptions = <
  TError = ErrorType<
    | DashboardTeamsControllerInvite400
    | DashboardTeamsControllerInvite401
    | DashboardTeamsControllerInvite404
    | DashboardTeamsControllerInvite429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerInvite>>,
    TError,
    { id: string; data: BodyType<DashboardTeamInvite> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTeamsControllerInvite>>,
  TError,
  { id: string; data: BodyType<DashboardTeamInvite> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTeamsControllerInvite>>,
    { id: string; data: BodyType<DashboardTeamInvite> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardTeamsControllerInvite(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTeamsControllerInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerInvite>>
>;
export type DashboardTeamsControllerInviteMutationBody = BodyType<DashboardTeamInvite>;
export type DashboardTeamsControllerInviteMutationError = ErrorType<
  | DashboardTeamsControllerInvite400
  | DashboardTeamsControllerInvite401
  | DashboardTeamsControllerInvite404
  | DashboardTeamsControllerInvite429
>;

/**
 * @summary Send team invite (dashboard)
 */
export const useDashboardTeamsControllerInvite = <
  TError = ErrorType<
    | DashboardTeamsControllerInvite400
    | DashboardTeamsControllerInvite401
    | DashboardTeamsControllerInvite404
    | DashboardTeamsControllerInvite429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerInvite>>,
    TError,
    { id: string; data: BodyType<DashboardTeamInvite> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTeamsControllerInvite>>,
  TError,
  { id: string; data: BodyType<DashboardTeamInvite> },
  TContext
> => {
  const mutationOptions = getDashboardTeamsControllerInviteMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Paginated tournament list filtered to tournaments where the team has at least one `tournament_registration`. Same response shape as `GET /api/dashboard/v1/tournaments`. Any caller-supplied `teamIds` query param is IGNORED — the path id always wins. 404 when the team is out of the caller's scope.
 * @summary List tournaments scoped to a team (dashboard)
 */
export const dashboardTeamsControllerTournaments = (
  id: string,
  params?: DashboardTeamsControllerTournamentsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentList>(
    { url: `/api/dashboard/v1/teams/${id}/tournaments`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTeamsControllerTournamentsQueryKey = (
  id: string,
  params?: DashboardTeamsControllerTournamentsParams
) => {
  return [`/api/dashboard/v1/teams/${id}/tournaments`, ...(params ? [params] : [])] as const;
};

export const getDashboardTeamsControllerTournamentsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
  TError = ErrorType<
    | DashboardTeamsControllerTournaments400
    | DashboardTeamsControllerTournaments401
    | DashboardTeamsControllerTournaments404
    | DashboardTeamsControllerTournaments429
  >,
>(
  id: string,
  params?: DashboardTeamsControllerTournamentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTeamsControllerTournamentsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>> = ({
    signal,
  }) => dashboardTeamsControllerTournaments(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTeamsControllerTournamentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>
>;
export type DashboardTeamsControllerTournamentsQueryError = ErrorType<
  | DashboardTeamsControllerTournaments400
  | DashboardTeamsControllerTournaments401
  | DashboardTeamsControllerTournaments404
  | DashboardTeamsControllerTournaments429
>;

export function useDashboardTeamsControllerTournaments<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
  TError = ErrorType<
    | DashboardTeamsControllerTournaments400
    | DashboardTeamsControllerTournaments401
    | DashboardTeamsControllerTournaments404
    | DashboardTeamsControllerTournaments429
  >,
>(
  id: string,
  params: undefined | DashboardTeamsControllerTournamentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerTournaments<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
  TError = ErrorType<
    | DashboardTeamsControllerTournaments400
    | DashboardTeamsControllerTournaments401
    | DashboardTeamsControllerTournaments404
    | DashboardTeamsControllerTournaments429
  >,
>(
  id: string,
  params?: DashboardTeamsControllerTournamentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerTournaments<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
  TError = ErrorType<
    | DashboardTeamsControllerTournaments400
    | DashboardTeamsControllerTournaments401
    | DashboardTeamsControllerTournaments404
    | DashboardTeamsControllerTournaments429
  >,
>(
  id: string,
  params?: DashboardTeamsControllerTournamentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List tournaments scoped to a team (dashboard)
 */

export function useDashboardTeamsControllerTournaments<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
  TError = ErrorType<
    | DashboardTeamsControllerTournaments400
    | DashboardTeamsControllerTournaments401
    | DashboardTeamsControllerTournaments404
    | DashboardTeamsControllerTournaments429
  >,
>(
  id: string,
  params?: DashboardTeamsControllerTournamentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTeamsControllerTournaments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTeamsControllerTournamentsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated league list filtered to leagues that have at least one tournament with a `tournament_registration` row for the team. Same response shape as `GET /api/dashboard/v1/leagues`. Any caller-supplied `teamIds` query param is IGNORED — the path id always wins. 404 when the team is out of the caller's scope.
 * @summary List leagues scoped to a team (dashboard)
 */
export const dashboardTeamsControllerLeagues = (
  id: string,
  params?: DashboardTeamsControllerLeaguesParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueList>(
    { url: `/api/dashboard/v1/teams/${id}/leagues`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTeamsControllerLeaguesQueryKey = (
  id: string,
  params?: DashboardTeamsControllerLeaguesParams
) => {
  return [`/api/dashboard/v1/teams/${id}/leagues`, ...(params ? [params] : [])] as const;
};

export const getDashboardTeamsControllerLeaguesQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>,
  TError = ErrorType<
    | DashboardTeamsControllerLeagues400
    | DashboardTeamsControllerLeagues401
    | DashboardTeamsControllerLeagues404
    | DashboardTeamsControllerLeagues429
  >,
>(
  id: string,
  params?: DashboardTeamsControllerLeaguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTeamsControllerLeaguesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>> = ({
    signal,
  }) => dashboardTeamsControllerLeagues(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTeamsControllerLeaguesQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>
>;
export type DashboardTeamsControllerLeaguesQueryError = ErrorType<
  | DashboardTeamsControllerLeagues400
  | DashboardTeamsControllerLeagues401
  | DashboardTeamsControllerLeagues404
  | DashboardTeamsControllerLeagues429
>;

export function useDashboardTeamsControllerLeagues<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>,
  TError = ErrorType<
    | DashboardTeamsControllerLeagues400
    | DashboardTeamsControllerLeagues401
    | DashboardTeamsControllerLeagues404
    | DashboardTeamsControllerLeagues429
  >,
>(
  id: string,
  params: undefined | DashboardTeamsControllerLeaguesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerLeagues<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>,
  TError = ErrorType<
    | DashboardTeamsControllerLeagues400
    | DashboardTeamsControllerLeagues401
    | DashboardTeamsControllerLeagues404
    | DashboardTeamsControllerLeagues429
  >,
>(
  id: string,
  params?: DashboardTeamsControllerLeaguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTeamsControllerLeagues<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>,
  TError = ErrorType<
    | DashboardTeamsControllerLeagues400
    | DashboardTeamsControllerLeagues401
    | DashboardTeamsControllerLeagues404
    | DashboardTeamsControllerLeagues429
  >,
>(
  id: string,
  params?: DashboardTeamsControllerLeaguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List leagues scoped to a team (dashboard)
 */

export function useDashboardTeamsControllerLeagues<
  TData = Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>,
  TError = ErrorType<
    | DashboardTeamsControllerLeagues400
    | DashboardTeamsControllerLeagues401
    | DashboardTeamsControllerLeagues404
    | DashboardTeamsControllerLeagues429
  >,
>(
  id: string,
  params?: DashboardTeamsControllerLeaguesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTeamsControllerLeagues>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTeamsControllerLeaguesQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
